import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
//コンポーネント
import TextField from "../../../ui/TextField";
import RangeField from "../../../ui/RangeField";
import CheckboxGroup from "../../../ui/CheckboxGroup";
import SearchCondition from "../../../features/SearchCondition";
import Button from "../../../ui/Button";
import Summary from "../../../ui/Summary";
import styles from "../../../layout/admin/Main.module.scss";
import RadioGroup from "../../../ui/RadioGroup";
//API
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
//バリデーション
import { validateMaxlength, validateNumber } from "../../../../utils/validate";

const codeLotteryStatus = "CD003"; //区分コード：抽選ステータス
const codeHowApply = "CD005"; //区分コード：申込方法
const codeAttendance = "CD004"; //区分コード：受講ステータス
const codeControled = "CD007"; //区分コード：公開ステータス

const controled = 1; //公開状態_公開

const SearchForm = ({ setSearchCondition }) => {
  //当選状況チェックボックス
  const [lotteryElements, setlotteryElements] = useState([]);
  //申込方法チェックボックス
  const [howApplyElements, setHowApplyElements] = useState([]);
  //受講ステータスチェックボックス
  const [attendanceElements, setAttendanceElements] = useState([]);
  //公開/非公開
  const [isControlElements, setIsControlElements] = useState([]);
  const [selectedIsControl, setSelectedIsControl] = useState(controled);
  useEffect(() => {
    const mapCodeFunc = (d) => {
      return {
        label: d.d_text,
        value: d.d_value,
      };
    };

    (async function () {
      //区分値チェックボックスセット
      //当選状況
      const lotteryData = await getCodeMasterList({ code: codeLotteryStatus });
      setlotteryElements(lotteryData.map(mapCodeFunc));
      //申込方法
      const hoeAppryData = await getCodeMasterList({ code: codeHowApply });
      setHowApplyElements(hoeAppryData.map(mapCodeFunc));
      //受講ステータス
      const attendanceData = await getCodeMasterList({ code: codeAttendance });
      setAttendanceElements(attendanceData.map(mapCodeFunc));
      //公開/非公開
      const controledData = await getCodeMasterList({ code: codeControled });
      setIsControlElements(controledData.map(mapCodeFunc));

      //初期チェック
      setSelectedIsControl(controled);
      setValue("control", String(controled));

      //初期検索
      setSearchCondition({ control: String(controled) });
    })();
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setSearchCondition(data);
  };

  const resetCondition = () => {
    setValue("course_name", "");
    setValue("univ_id", "");
    setValue("applicant_id", "");
    setValue("updated_at_s", "");
    setValue("updated_at_e", "");
    lotteryElements.forEach((elm) => {
      setValue("lottery_status_" + elm.value, false);
    });
    howApplyElements.forEach((elm) => {
      setValue("how_apply_" + elm.value, false);
    });
    attendanceElements.forEach((elm) => {
      setValue("attendance_status_" + elm.value, false);
    });
    setValue("attendance_updated_date_s", "");
    setValue("attendance_updated_date_e", "");
    setSelectedIsControl(controled);
  };

  return (
    <div>
      <details open>
        <Summary />
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchCondition title="申込済み講座を絞り込む">
            <table>
              <tr>
                <TextField
                  register={register}
                  name="course_name"
                  errors={errors}
                  label="講座名"
                  placeholder="講座名"
                  validation={{ ...validateMaxlength(100) }}
                ></TextField>
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="当選状況"
                  name="lottery_status"
                  elements={lotteryElements}
                />
              </tr>
              <tr>
                <TextField
                  register={register}
                  name="univ_id"
                  errors={errors}
                  label="大学ID"
                  placeholder="大学ID"
                  validation={{ ...validateMaxlength(100) }}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  name="applicant_id"
                  errors={errors}
                  label="申込者ID"
                  placeholder="申込者ID"
                  validation={{
                    ...validateMaxlength(100),
                    ...validateNumber(),
                  }}
                ></TextField>
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="申込方法"
                  name="how_apply"
                  elements={howApplyElements}
                />
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="未受講・受講中・受講済み"
                  name="attendance_status"
                  elements={attendanceElements}
                />
              </tr>
              <tr>
                <RangeField
                  type="date"
                  register={register}
                  nameFrom={"attendance_updated_date_s"}
                  nameTo={"attendance_updated_date_e"}
                  errors={errors}
                  label="出欠情報更新日時"
                ></RangeField>
              </tr>
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="公開・非公開"
                  name="control"
                  elements={isControlElements}
                  watch={watch}
                  selectedValue={selectedIsControl}
                  setSelectedValue={setSelectedIsControl}
                />
              </tr>
            </table>

            {errors.exampleRequired && <span>This field is required</span>}
          </SearchCondition>
          <div className={styles.buttonbox}>
            <Button type="submit" styleType="search">
              検索
            </Button>
            <Button
              type="button"
              styleType="back"
              onClick={() => resetCondition()}
            >
              条件クリア
            </Button>
          </div>
        </form>
      </details>
    </div>
  );
};

export default SearchForm;
